'use client';
import { EventBus } from '@s7/event-bus';
import { isBrowser } from '@s7/platform';
import { objectEntries } from '@s7/utils';
import { AnalyticsWorker } from './AnalyticsWorker/AnalyticsWorker.js';
import { AnalyticsTopic } from './AnalyticsTopic/AnalyticsTopic.js';

const AnalyticsManager = (options)=>{
    const { transform: globalTransform, plugins, listeners } = options;
    const bus = EventBus();
    const worker = AnalyticsWorker({
        bus,
        plugins
    });
    /**
     * Прикрепляем слушателей шины до запуска.
     * */ if (listeners) {
        objectEntries(listeners).forEach(([eventName, listener])=>{
            bus.on(eventName, listener);
        });
    }
    /**
     * Запускаем инициализацию плагинов и прослушивание событий только на клиенте.
     * */ if (isBrowser) {
        worker.init().listen();
    }
    const analyticsManager = {
        createTopic
    };
    function createTopic(transform) {
        return AnalyticsTopic({
            bus,
            transforms: [
                globalTransform,
                transform
            ]
        });
    }
    return analyticsManager;
};

export { AnalyticsManager };
//# sourceMappingURL=AnalyticsManager.js.map
